module.exports = __webpack_public_path__ + "da68fd2b3d58df0c9d18a6aa4a2b4e87.pdf";